import { lazy } from 'react';

const ReceivedTransferConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/manager/consults/received/transfer-info',
			component: lazy(() => import('./ReceivedTransferContainer'))
		}
	]
};

export default ReceivedTransferConfig;

